import React from 'react';
import './NotFound.scss'


export const  Page404 = ()=>{
    document.title = "Not Found"
    return <>
        <div className="container-notfound">
            <div className="notfound">
             <img  src="./assets/images/404.svg"  alt=""/>
             <h4>Questa Pagina non è disponibile</h4>
             <p>Il link potrebbe essere non funzionante o la Pagina potrebbe essere stata rimossa. Verifica che il link che stai cercando di aprire sia corretto.</p>
            </div>
           
        </div>
    </>
}